import React from 'react';

const ScanViewer = ({ embedCode }) => {
  return (
    <div className="bg-gray-100 p-4 rounded-lg">
      <div className="aspect-w-16 aspect-h-9">
        <div dangerouslySetInnerHTML={{ __html: embedCode }} />
      </div>
    </div>
  );
};

export default ScanViewer;